import * as types from './action-types';
// import { PanelProxy } from '../../../proxies';

const clearData = () => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({type: types.SET_SINGLE_FINANCIAL_DATA, payload: { data: {id:null}, key: 'userData'}});
  });
};

const dispatchState = (stateName, value) => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({type: types.SET_SINGLE_FINANCIAL_DATA, payload: { data: {stateName:stateName, value: value}, key: 'dispatchState'}});
  });
};

export default {
  clearData,
  dispatchState
}


// WEBPACK FOOTER //
// ./src/store/modules/financial/actions.js